import {actions} from '../../actions/action-list';
import initialState from "./initialState";

function SideBarToggle(state = initialState, action) {
    switch (action.type) {
        case actions.TOGGLE_SIDEBAR:
            return Object.assign({}, state, {
                togglerValue: action.value
            });
        default:
            return state;
    }
}
export default SideBarToggle;
